<template>
  <!-- Añadir justo antes del header -->
  <div class="shipping-banner ">
    <div class="shipping-content">
      <div class="shipping-text">
        <span class="banner-item fs-7">
          <i class="fas fa-truck me-1" aria-hidden="true"></i>
          Envíos a todo el país
        </span>
        <span class="banner-separator" aria-hidden="true">•</span>
        <span class="banner-item fs-7">
          <i class="fas fa-medal me-1" aria-hidden="true"></i>
          Garantía de germinación en todos los productos
        </span>
        <span class="banner-separator" aria-hidden="true">•</span>
        <span class="banner-item fs-7">
          <i class="fas fa-lock me-1" aria-hidden="true"></i>
          Compra 100% segura
        </span>
        <span class="banner-separator" aria-hidden="true">•</span>
        <span class="banner-item fs-7">
          <i class="fas fa-truck me-1" aria-hidden="true"></i>
          Envíos a todo el país
        </span>
        <span class="banner-separator" aria-hidden="true">•</span>
        <span class="banner-item fs-7">
          <i class="fas fa-medal me-1" aria-hidden="true"></i>
          Garantía de germinación en todos los productos
        </span>
      </div>
    </div>
  </div>
  <header ref="navbarHeader" class="fixed-top w-100" style="top: 40px;">
    <nav class="navbar navbar-expand-lg px-3" :class="{ 'navbar-scrolled': scrolled }" aria-label="Principal">
      <div class="container">
        <a href="/" aria-label="Semillero del Oeste — Ir al inicio" class="logo-link">
          <img
            src="@/assets/images/logo.webp"
            alt=""
            class="logo-img img-fluid"
            width="49"
            height="70"
            decoding="async"
          />
        </a>

        <!-- Desktop Menu -->
        <div class="d-none d-lg-flex align-items-center justify-content-between flex-grow-1">          <ul class="navbar-nav mx-2">
            <li v-for="(item, index) in menuItems" :key="index" class="nav-item">
              <a 
                v-if="item.external"
                :href="item.route"
                class="nav-link fw-semibold"
                target="_blank"
              >
                <i :class="item.icon" class="me-1" aria-hidden="true"></i>
                {{ item.label }}
              </a>
              <a 
                v-else
                :href="item.route"
                class="nav-link fw-semibold"
                @click.prevent="navigateTo(item)"
              >
                <i :class="item.icon" class="me-1" aria-hidden="true"></i>
                {{ item.label }}
              </a>
            </li>
          </ul>
          <div class="d-flex gap-2">
            <!-- Search Bar -->
            <div class="search-container me-2">
              <form @submit.prevent="handleSearch" class="search-form" role="search">
                <label for="navbar-search-desktop" class="visually-hidden">Buscar productos</label>
                <input
                  id="navbar-search-desktop"
                  type="search"
                  v-model="searchQuery"
                  class="search-input"
                  placeholder="Buscar productos..."
                  autocomplete="off"
                  aria-describedby="navbar-search-desktop-hint"
                  @focus="handleSearchFocus"
                  @blur="handleSearchBlur"
                  @input="handleSearchInput"
                >
                <span id="navbar-search-desktop-hint" class="visually-hidden">Escribí al menos dos caracteres para ver sugerencias</span>
                <button type="submit" class="search-button" aria-label="Ejecutar búsqueda">
                  <i class="fas fa-search" aria-hidden="true"></i>
                </button>
              </form>
  
              <!-- Dropdown de resultados -->
              <div v-if="showResults && filteredProducts.length > 0" class="search-results">
                <router-link
                  v-for="product in filteredProducts"
                  :key="product.id"
                  :to="`/producto/${product.id}`"
                  class="search-result-item"
                  @click="clearSearch"
                >
                  <img :src="product.image" :alt="product.name" class="search-result-img" @error="handleImageError">
                  <div class="search-result-info">
                    <div class="search-result-name">{{ product.name }}</div>
                    <div class="search-result-brand">{{ product.brand }}</div>
                  </div>
                </router-link>
                <div class="search-results-footer">
                  <button @click="viewAllResults" class="view-all-btn">
                    Ver todos los resultados
                  </button>
                </div>
              </div>
            </div>
  
            <!-- Auth & Cart Icons -->
            <div class="nav-actions d-flex gap-2">
              <router-link
                :to="isAuthenticated ? '/mi-cuenta' : '/login'"
                class="btn btn-primary account-btn"
              >
                <i class="fas fa-user" aria-hidden="true"></i>
                <span class="ms-2 d-none d-sm-inline">{{ isAuthenticated ? username : "Mi cuenta" }}</span>
              </router-link>
              
              <router-link
                to="/carrito"
                class="cart-btn"
                :aria-label="cartItemsCount > 0 ? `Ver carrito, ${cartItemsCount} artículos` : 'Ver carrito'"
              >
                <div class="cart-icon-wrapper">
                  <i class="fas fa-shopping-cart" aria-hidden="true"></i>
                  <transition name="bounce">
                    <span v-if="cartItemsCount > 0" class="cart-counter">{{ cartItemsCount }}</span>
                  </transition>
                </div>
              </router-link>
            </div>
          </div>
        </div>

        <!-- Mobile Menu Button & Cart -->
        <div class="d-flex d-lg-none align-items-center gap-3">
          <button type="button" class="mobile-search-btn" @click="toggleMobileSearch" aria-label="Abrir búsqueda de productos">
            <i class="fas fa-search" aria-hidden="true"></i>
          </button>
          <router-link
            to="/carrito"
            class="cart-btn"
            :aria-label="cartItemsCount > 0 ? `Ver carrito, ${cartItemsCount} artículos` : 'Ver carrito'"
          >
            <div class="cart-icon-wrapper">
              <i class="fas fa-shopping-cart" aria-hidden="true"></i>
              <transition name="bounce">
                <span v-if="cartItemsCount > 0" class="cart-counter">{{ cartItemsCount }}</span>
              </transition>
            </div>
          </router-link>

          <button
            type="button"
            class="menu-toggle"
            :class="{ 'is-active': isMenuOpen }"
            @click="toggleMenu"
            :aria-expanded="isMenuOpen"
            aria-controls="primary-mobile-navigation"
            aria-label="Menú de navegación"
          >
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </button>
        </div>
      </div>
    </nav>

    <!-- Mobile Search Bar -->
    <div class="mobile-search" :class="{ 'mobile-search-active': showMobileSearch }">
      <form @submit.prevent="handleSearch" class="mobile-search-form" role="search">
        <label for="navbar-search-mobile" class="visually-hidden">Buscar productos</label>
        <input
          id="navbar-search-mobile"
          type="search"
          v-model="searchQuery"
          class="mobile-search-input"
          placeholder="Buscar productos..."
          autocomplete="off"
        >
        <button type="submit" class="mobile-search-button" aria-label="Ejecutar búsqueda">
          <i class="fas fa-search" aria-hidden="true"></i>
        </button>
        <button type="button" class="mobile-search-close" @click="toggleMobileSearch" aria-label="Cerrar búsqueda">
          <i class="fas fa-times" aria-hidden="true"></i>
        </button>
      </form>
    </div>

    <!-- Mobile Menu -->
    <transition name="slide-down">
      <div v-if="isMenuOpen" id="primary-mobile-navigation" class="mobile-menu" :style="{ top: mobileMenuTop + 'px' }" @click.self="closeMenu">
        <div class="mobile-menu-container">          <ul class="mobile-nav">
            <li v-for="(item, index) in menuItems" :key="index">
              <a 
                v-if="item.external"
                :href="item.route"
                class="mobile-nav-link text-decoration-none"
                target="_blank"
                @click="closeMenu"
              >
                <i :class="item.icon" class="me-3" aria-hidden="true"></i>
                {{ item.label }}
              </a>
              <a 
                v-else
                :href="item.route"
                class="mobile-nav-link text-decoration-none"
                @click.prevent="() => { navigateTo(item); closeMenu(); }"
              >
                <i :class="item.icon" class="me-3" aria-hidden="true"></i>
                {{ item.label }}
              </a>
            </li>
            <li class="mobile-nav-account">
              <router-link to="/mi-cuenta" class="btn btn-primary w-100" @click="closeMenu">
                <i class="fas fa-user me-1" aria-hidden="true"></i>
                {{ isAuthenticated ? username : "Mi cuenta" }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </transition>
  </header>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from 'vue-router';
import authStore from '@/store/authStore';

const store = useStore();
const scrolled = ref(false);
const isMenuOpen = ref(false);
const navbarHeader = ref(null);
const mobileMenuTop = ref(140); // fallback; se recalcula al abrir el menú

// Pegar el menú mobile al borde inferior real del navbar (el header es fixed,
// así que su bottom no depende del scroll)
const updateMobileMenuTop = () => {
  if (navbarHeader.value) {
    mobileMenuTop.value = navbarHeader.value.getBoundingClientRect().bottom;
  }
};

// Procesar el nombre de usuario para mostrar solo la parte anterior al @ si es un email
const username = computed(() => {
  const currentUsername = authStore.state.username;
  if (currentUsername && currentUsername.includes('@')) {
    return currentUsername.split('@')[0];
  }
  return currentUsername;
});

// Function to handle image loading errors
const handleImageError = (event) => {
  // Set the default logo image when product images fail to load
  event.target.src = require('@/assets/images/logo.png');
};

// Función reactiva para obtener productos disponibles
const products = computed(() => {
  const allProducts = JSON.parse(localStorage.getItem("products")) || [];
  // Filtrar solo productos disponibles para el navbar (usuarios públicos)
  return allProducts.filter(product => product.available !== false);
});

const menuItems = [
  { label: 'Artículos', route: 'https://jamrockgrowshop.com.ar', icon: 'fas fa-bong', external: true },
  { label: 'Bancos', route: '/bancos/', icon: 'fas fa-building' },
  { label: 'Automáticas', route: '/productos?categories=automaticas', icon: 'fas fa-seedling' },
  { label: 'Feminizadas', route: '/productos?categories=feminizadas', icon: 'fas fa-venus' },
  { label: 'Fast Flowering', route: '/productos?categories=fast-flowering', icon: 'fas fa-bolt' },
  { label: 'Ofertas', route: '/productos?category=ofertas', icon: 'fas fa-tags' }
];

// Computed property para verificar autenticación
const isAuthenticated = computed(() => {
  return authStore.state.isAuthenticated;
});

// Computed property for cart count from Vuex store
const cartItemsCount = computed(() => store.getters.cartCount);

const router = useRouter();
const searchQuery = ref('');
const showMobileSearch = ref(false);

// Esta función maneja la navegación de los elementos del menú
const navigateTo = (item) => {
  // Extraer la ruta base y la query string
  const [path, queryString] = item.route.split('?');
  
  // Convertir la query string en un objeto
  const params = {};
  if (queryString) {
    const searchParams = new URLSearchParams(queryString);
    searchParams.forEach((value, key) => {
      params[key] = value;
    });
  }

  // Usar una solución más directa para recargar la página con los nuevos parámetros
  // Primero construir la nueva URL completa
  const baseUrl = window.location.origin + path;
  const queryPart = new URLSearchParams(params).toString();
  const fullUrl = baseUrl + (queryPart ? '?' + queryPart : '');
  
  // Recargar la página con la nueva URL
  window.location.href = fullUrl;
};

const handleSearch = () => {
  if (searchQuery.value.trim()) {
    // Construir los parámetros de consulta
    const params = {
      search: searchQuery.value.trim()
    };
    
    // Mantener otros filtros activos
    if (router.currentRoute.value.query.categories) {
      params.categories = router.currentRoute.value.query.categories;
    }
    if (router.currentRoute.value.query.banks) {
      params.banks = router.currentRoute.value.query.banks;
    }
    
    // Construir la URL completa
    const baseUrl = window.location.origin + '/productos';
    const queryPart = new URLSearchParams(params).toString();
    const fullUrl = baseUrl + (queryPart ? '?' + queryPart : '');
    
    // Recargar la página con la nueva URL
    window.location.href = fullUrl;
    
    searchQuery.value = '';
    showMobileSearch.value = false;
  }
};

const toggleMobileSearch = () => {
  showMobileSearch.value = !showMobileSearch.value;
};

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;
  scrolled.value = isMenuOpen.value;
  if (isMenuOpen.value) {
    updateMobileMenuTop();
  }
};

const closeMenu = () => {
  isMenuOpen.value = false;
};

const handleScroll = () => {
  scrolled.value = window.scrollY > 50;
};

const handleResize = () => {
  if (isMenuOpen.value) {
    updateMobileMenuTop();
  }
};


onMounted(() => {
  window.addEventListener("scroll", handleScroll);
  window.addEventListener("resize", handleResize);
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
  window.removeEventListener("resize", handleResize);
});

// Estado para búsqueda
const showResults = ref(false);
const filteredProducts = ref([]);

// Manejar focus del input
const handleSearchFocus = () => {
  scrolled.value = true;
  showResults.value = true;
  handleSearchInput();
};

// Manejar blur del input
const handleSearchBlur = () => {
  setTimeout(() => {
    showResults.value = false;
    if (!isMenuOpen.value && window.scrollY <= 50) {
      scrolled.value = false;
    }
  }, 200);
};

const handleSearchInput = () => {
  if (searchQuery.value.length >= 2) {
    filteredProducts.value = products.value
      .filter(product => {
        const query = searchQuery.value.toLowerCase();
        return (
          product.name.toLowerCase().includes(query) ||
          product.brand.toLowerCase().includes(query)
        );
      })
      .slice(0, 5);
  } else {
    filteredProducts.value = [];
  }
};

// Limpiar búsqueda
const clearSearch = () => {
  searchQuery.value = '';
  showResults.value = false;
};

// Ver todos los resultados
const viewAllResults = () => {
  // Construir los parámetros de consulta
  const params = {
    search: searchQuery.value
  };
  
  // Mantener otros filtros activos
  if (router.currentRoute.value.query.categories) {
    params.categories = router.currentRoute.value.query.categories;
  }
  if (router.currentRoute.value.query.banks) {
    params.banks = router.currentRoute.value.query.banks;
  }
  
  // Construir la URL completa
  const baseUrl = window.location.origin + '/productos';
  const queryPart = new URLSearchParams(params).toString();
  const fullUrl = baseUrl + (queryPart ? '?' + queryPart : '');
  
  // Recargar la página con la nueva URL
  window.location.href = fullUrl;
  
  clearSearch();
};
</script>

<style scoped>
/* Base Styles */
.navbar {
  padding: 0.75rem 0;
  transition: all 0.3s ease;
  background: transparent;
}

.navbar-scrolled {
  background: rgba(0, 0, 0, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.navbar-brand {
  width: 200px;
}

.logo-link {
  text-decoration: none;
  display: inline-flex;
  align-items: center;
}

.logo-img {
  height: 70px !important;
  width: auto;
  max-width: 52px;
  object-fit: contain;
}

/* Navigation Links */
.nav-link {
  position: relative;
  padding: 0.5rem 1rem;
  color: var(--white-color);
  font-weight: 500;
  transition: all 0.3s ease;
  margin: 0 0.5rem;
  cursor: pointer;
  font-size: 14px;
}

.nav-link:hover {
  color: var(--primary-color);
  transform: translateY(-2px);
}

.nav-link::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 2px;
  background: var(--primary-color);
  transform: scaleX(0);
  transition: transform 0.3s ease;
  transform-origin: right;
}

.nav-link:hover::after {
  transform: scaleX(1);
  transform-origin: left;
}

/* Action Buttons */
.nav-actions {
  display: flex;
  align-items: center;
}

.account-btn {
  padding: 0.5rem 1rem;
  border-radius: 50px;
  transition: all 0.3s ease;
}

.account-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
}

.cart-btn {
  position: relative;
  padding: 0.5rem;
  color: var(--white-color);
  text-decoration: none;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  min-height: 44px;
  box-sizing: border-box;
}

.cart-btn:hover {
  color: var(--primary-color);
}

.cart-icon-wrapper {
  position: relative;
  font-size: 1.25rem;
  min-width: 1.25em;
  min-height: 1.25em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.cart-icon-wrapper .fas {
  display: inline-block;
  width: 1.25em;
  text-align: center;
  line-height: 1;
}

.cart-counter {
  position: absolute;
  top: -8px;
  right: -8px;
  background: var(--primary-color);
  color: white;
  min-width: 20px;
  height: 20px;
  border-radius: 10px;
  font-size: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

/* Mobile Menu Button */
.menu-toggle {
  width: 44px;
  height: 44px;
  position: relative;
  background: none;
  border: none;
  padding: 10px;
  box-sizing: border-box;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.menu-toggle span {
  display: block;
  width: 24px;
  height: 2px;
  background: var(--white-color);
  position: absolute;
  left: 0;
  transition: all 0.3s ease;
}

.menu-toggle span:nth-child(1) { top: 13px; left: 10px; position: absolute; }
.menu-toggle span:nth-child(2) { top: 50%; left: 10px; position: absolute; transform: translateY(-50%); width: 24px; }
.menu-toggle span:nth-child(3) { bottom: 13px; left: 10px; position: absolute; }

.menu-toggle.is-active span:nth-child(1) { transform: rotate(45deg) translate(5px, 5px); }
.menu-toggle.is-active span:nth-child(2) { opacity: 0; }
.menu-toggle.is-active span:nth-child(3) { transform: rotate(-45deg) translate(6px, -6px); }

/* Mobile Menu */
.mobile-menu {
  position: fixed;
  top: 140px;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  z-index: 1000;
}

.mobile-menu-container {
  padding: 2rem;
  background: var(--black-color);
}

.mobile-nav {
  list-style: none;
  padding: 0;
  margin: 0;
}

.mobile-nav-link {
  display: flex;
  align-items: center;
  padding: 1rem;
  color: var(--white-color);
  font-size: 1.1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.mobile-nav-link:hover {
  background: rgba(255, 255, 255, 0.05);
  padding-left: 1.5rem;
}

.mobile-nav-account {
  margin-top: 2rem;
  padding: 0 1rem;
}

/* Animations */
.bounce-enter-active {
  animation: bounce-in 0.5s;
}

.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}

@keyframes bounce-in {
  0% { transform: scale(0); }
  50% { transform: scale(1.2); }
  100% { transform: scale(1); }
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease;
}

.slide-down-enter-from,
.slide-down-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}

/* Responsive Adjustments */
@media (max-width: 991.98px) {
  .navbar {
    padding: 0.5rem 0;
  }
  
  .logo-img {
    height: 50px !important;
    max-width: 40px;
  }
  
  .cart-counter {
    min-width: 18px;
    height: 18px;
    font-size: 0.7rem;
  }
}

/* Search Styles */
.search-container {
  position: relative;
  width: 300px;
}

.search-form {
  display: flex;
  align-items: center;
}

.search-input {
  width: 100%;
  padding: 0.5rem 1rem;
  padding-right: 2.5rem;
  border: none;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.1);
  color: var(--white-color);
  transition: all 0.3s ease;
}

.search-input:focus {
  background: rgba(255, 255, 255, 0.15);
  outline: none;
  box-shadow: 0 0 0 2px var(--primary-color);
}

.search-button {
  position: absolute;
  right: 0.35rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: var(--white-color);
  padding: 0.5rem;
  min-width: 44px;
  min-height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.3s ease;
}

.search-button:hover {
  opacity: 1;
}

/* Mobile Search Styles */
.mobile-search {
  position: fixed;
  top: -100%;
  left: 0;
  width: 100%;
  background: var(--black-color-3);
  padding: 1rem;
  transition: top 0.3s ease;
  z-index: 1000;
}

.mobile-search-active {
  top: 40px;
}

.mobile-search-form {
  display: flex;
  gap: 0.5rem;
}

.mobile-search-input {
  flex: 1;
  padding: 0.75rem 1rem;
  border: none;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  color: var(--white-color);
}
.mobile-search-button,
.mobile-search-close {
  background: none;
  border: none;
  color: var(--white-color);
  padding: 0.5rem;
  font-size: 1.2rem;
  min-width: 44px;
  min-height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.mobile-search-btn {
  background: none;
  border: none;
  color: var(--white-color);
  font-size: 1.2rem;
  padding: 0.5rem;
  min-width: 44px;
  min-height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.shipping-banner {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 40px;
  background-color: var(--primary-color);
  overflow: hidden;
  z-index: 1100;
}

.shipping-content {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}

.shipping-text {
  color: white;
  font-weight: 500;
  white-space: nowrap;
  animation: scrollText 30s linear infinite; /* Reducido a 20s para mayor velocidad */
  padding: 0 2rem;
  display: flex;
  align-items: center;
  gap: 1rem; /* Añadido gap entre elementos */
}

.banner-item {
  padding: 0 2rem; /* Aumentado el padding */
  display: flex;
  align-items: center;
  font-size: 0.9rem; /* Tamaño de fuente ligeramente reducido */
}

.banner-separator {
  color: rgba(255, 255, 255, 0.5);
  margin: 0 2rem; /* Aumentado el margen */
  font-size: 1.2rem; /* Punto separador más grande */
}

@keyframes scrollText {
  0% {
    transform: translateX(50%); /* Cambiado a 50% para que aparezca antes */
  }
  100% {
    transform: translateX(-100%);
  }
}

/* Ajustar altura de navbar en móviles */
@media (max-width: 991.98px) {
  .mobile-menu {
    top: 140px;
  }
}

.search-results {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: var(--black-color-3);
  border-radius: 8px;
  margin-top: 0.5rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  z-index: 1000;
  border: 1px solid rgba(255, 255, 255, 0.1);
  overflow: hidden;
}

.search-result-item {
  display: flex;
  align-items: center;
  padding: 0.75rem;
  text-decoration: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: background-color 0.2s ease;
}

.search-result-item:hover {
  background: rgba(255, 255, 255, 0.05);
}

.search-result-img {
  width: 40px;
  height: 40px;
  object-fit: contain;
  margin-right: 1rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
}

.search-result-info {
  flex: 1;
}

.search-result-name {
  color: var(--white-color);
  font-size: 0.9rem;
  font-weight: 500;
}

.search-result-brand {
  color: var(--white-color-2);
  font-size: 0.8rem;
  opacity: 0.7;
}

.search-results-footer {
  padding: 0.75rem;
  text-align: center;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.view-all-btn {
  background: none;
  border: none;
  color: var(--primary-color);
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.view-all-btn:hover {
  text-decoration: underline;
}
</style>
